import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=6cd98af8&scoped=true&"
import script from "./ConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationPage.vue?vue&type=style&index=0&id=6cd98af8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd98af8",
  null
  
)

export default component.exports